import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Gift } from "lucide-react";
import { api } from "@/lib/api";
import { PromoList } from "@/components/invite/PromoList";

const KEY = "lr_ref";
const VALID = /^[A-Za-z0-9_-]{6,24}$/;

export const useInviteRef = (active) => {
  const [params] = useSearchParams();
  const [ref, setRef] = useState(() => localStorage.getItem(KEY) || "");
  useEffect(() => {
    const r = params.get("ref");
    if (active && r && VALID.test(r)) { localStorage.setItem(KEY, r); setRef(r); }
  }, [params, active]);
  return active ? ref : "";
};

export const InviteWelcome = ({ code }) => {
  const { data, isError } = useQuery({ queryKey: ["invite", code], queryFn: () => api.get(`/public/invite/${code}`).then((r) => r.data), retry: false, staleTime: 300000 });
  useEffect(() => { if (isError) localStorage.removeItem(KEY); }, [isError]);
  if (!data) return null;
  return (
    <div className="-mt-6 mb-8 rounded-md border border-[#F59E0B]/35 bg-[#F59E0B]/[0.06] p-4 animate-in fade-in slide-in-from-bottom-1 duration-500" data-testid="invite-welcome">
      <p className="flex items-start gap-2 text-sm text-[#F3EBDD]"><Gift className="mt-0.5 h-4 w-4 shrink-0 text-[#FBBF24]" />
        <span data-testid="invite-welcome-text"><span className="font-medium">{data.inviter} invited you</span> — start with a {data.trial_days}-day Pro trial.</span></p>
      <PromoList promos={data.promotions} className="mt-3" />
    </div>
  );
};
